<template>
  <add-or-update pageType="add"></add-or-update>
</template>

<script>
import addOrUpdate from "./components/addOrUpdate";
export default {
  name: "driversManageAdd",
  components: {
    addOrUpdate
  }
};
</script>
